<template>
  <div v-if="hint" :id="description">
    <p v-for="(hint, index) in formatHint" :key="index">
      {{ hint }}
    </p>
  </div>
</template>

<script>
export default {
  name: "DoeHint",
  props: {
    hint: {
      type: [Array, String]
    },
    description: {
      type: String
    }
  },
  computed: {
    formatHint() {
      if (!Array.isArray(this.hint)) {
        return new Array(this.hint);
      } else {
        return this.hint;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  @apply font-sans font-light leading-relaxed max-w-3xl mt-1 subpixel-antialiased text-sm text-gray-900 w-full;
}
</style>
